function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $8acc2c0717e3c0a9$exports = {};

$parcel$export($8acc2c0717e3c0a9$exports, "ANIMATION", () => $8acc2c0717e3c0a9$export$a8fef325e42f6db3);
const $4d8ea4346a043b91$export$908fab926188d723 = {
    SLOWEST: 700,
    SLOWER: 600,
    SLOW: 500,
    DEFAULT: 400,
    FAST: 300,
    FASTER: 200,
    FASTEST: 100
};


const $8acc2c0717e3c0a9$export$a8fef325e42f6db3 = {
    SPEEDS: $4d8ea4346a043b91$export$908fab926188d723
};


var $0cde332632c6cb01$exports = {};

$parcel$export($0cde332632c6cb01$exports, "BORDERS", () => $0cde332632c6cb01$export$ba7bb3842aa42e48);
var $fd56662dee1a030a$exports = {};

$parcel$export($fd56662dee1a030a$exports, "BASE_FONT_SIZE", () => $fd56662dee1a030a$export$268e222a7ce18ec6);
const $fd56662dee1a030a$export$268e222a7ce18ec6 = 16;


const $e85bb647ce717a8b$export$7ef8b05b9f57e903 = {
    value: 2,
    px: "2px",
    rem: `${2 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $e85bb647ce717a8b$export$59096964bd9627ef = {
    value: 4,
    px: "4px",
    rem: `${4 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $e85bb647ce717a8b$export$3c37c3bdb860ae1e = {
    value: 8,
    px: "8px",
    rem: `${8 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $e85bb647ce717a8b$export$6ebfb25b2e903298 = {
    value: 16,
    px: "16px",
    rem: `${16 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $e85bb647ce717a8b$export$b225dbe5fb1f12f8 = {
    value: 24,
    px: "24px",
    rem: `${24 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $e85bb647ce717a8b$export$8214debbabae9604 = {
    value: 32,
    px: "32px",
    rem: `${32 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $e85bb647ce717a8b$export$2b4cb8204be4ae5e = {
    value: 50,
    px: "50px",
    rem: `${50 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $e85bb647ce717a8b$export$c53d0f541b41b88e = {
    value: 0,
    px: "0px",
    rem: "0rem"
};
const $e85bb647ce717a8b$export$e6952b12ade67489 = {
    value: 4,
    px: "4px",
    rem: `${4 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $e85bb647ce717a8b$export$2d2c9be8b5b863f = {
    XS: $e85bb647ce717a8b$export$7ef8b05b9f57e903,
    SM: $e85bb647ce717a8b$export$59096964bd9627ef,
    MD: $e85bb647ce717a8b$export$3c37c3bdb860ae1e,
    LG: $e85bb647ce717a8b$export$6ebfb25b2e903298,
    XL: $e85bb647ce717a8b$export$b225dbe5fb1f12f8,
    XXL: $e85bb647ce717a8b$export$8214debbabae9604,
    CIRCLE: $e85bb647ce717a8b$export$2b4cb8204be4ae5e,
    NONE: $e85bb647ce717a8b$export$c53d0f541b41b88e,
    DEFAULT: $e85bb647ce717a8b$export$e6952b12ade67489
};


const $5af2a904968a1ebd$export$79da56e68768f276 = {
    SOLID: "solid",
    DASHED: "dashed"
};


const $0434c00b13698167$export$87d0ca22edb7493a = {
    ALL: "",
    LEFT_RIGHT: "",
    TOP_BOTTOM: "",
    TOP: "",
    RIGHT: "",
    BOTTOM: "",
    LEFT: ""
};


const $0cde332632c6cb01$export$ba7bb3842aa42e48 = {
    SIZE: 1,
    RADIUS: $e85bb647ce717a8b$export$2d2c9be8b5b863f,
    STYLE: $5af2a904968a1ebd$export$79da56e68768f276,
    LOCATION: $0434c00b13698167$export$87d0ca22edb7493a
};


var $c9a2d196d5ac23f3$exports = {};

$parcel$export($c9a2d196d5ac23f3$exports, "BREAKPOINTS", () => $c9a2d196d5ac23f3$export$426e07cd0772984d);
$parcel$export($c9a2d196d5ac23f3$exports, "DEVICES", () => $c9a2d196d5ac23f3$export$7e1b78538df536d8);
const $c9a2d196d5ac23f3$export$426e07cd0772984d = {
    SM: 600,
    MD: 905,
    LG: 1240,
    XL: 1400
};
const $c9a2d196d5ac23f3$export$7e1b78538df536d8 = {
    SM: `(min-width: ${$c9a2d196d5ac23f3$export$426e07cd0772984d.SM}px)`,
    MD: `(min-width: ${$c9a2d196d5ac23f3$export$426e07cd0772984d.MD}px)`,
    LG: `(min-width: ${$c9a2d196d5ac23f3$export$426e07cd0772984d.LG}px)`,
    XL: `(min-width: ${$c9a2d196d5ac23f3$export$426e07cd0772984d.XL}px)`
};


var $5ecbefaf714b3608$exports = {};

$parcel$export($5ecbefaf714b3608$exports, "COLORS", () => $5ecbefaf714b3608$export$56d196d2844d1ca1);
const $68f5c7d2b84fdd64$export$9c2c904c75cdf110 = {
    DARKEST: "#880603",
    DARKER: "#AE2B28",
    DARK: "#CD332F",
    DEFAULT: "#E53935",
    LIGHT: "#F89E9C",
    LIGHTER: "#FFCDD2",
    LIGHTEST: "#FFEBEE"
};


const $a25a9bd37d8d246b$export$8cbd6e16cb024bee = {
    BLACK: "#192026",
    DARKEST: "#404A52",
    DARKER: "#687382",
    DARK: "#A9B1BC",
    DEFAULT: "#DCE1E6",
    LIGHT: "#EDEDE8",
    LIGHTER: "#F7F5F4",
    LIGHTEST: "#FFFAF4",
    WHITE: "#FFFFFF",
    BLACK_TRANSPARENT: "rgba(25, 32, 38, 0.75)",
    TRANSPARENT: "transparent"
};


const $3cb4d9c0e0bb20b9$export$fd2a60be71b279b3 = {
    DARKEST: "#00263E",
    DARKER: "#043452",
    DARK: "#084367",
    DEFAULT: "#0B4A72",
    LIGHT: "#DCE9EF",
    LIGHTER: "#EEF4F9",
    LIGHTEST: "#F6F9FC"
};


const $0511212feaf5f145$export$ff5b17dd5d816620 = {
    DARKEST: "#003366",
    DARKER: "#004B96",
    DARK: "#095DB0",
    DEFAULT: "#1976D2",
    LIGHT: "#ACDCE5",
    LIGHTER: "#E0F3F5",
    LIGHTEST: "#F0FDFF"
};


const $56f49b91f684431c$export$638cc6e36b2a737a = {
    DARKEST: "#004E46",
    DARKER: "#08655C",
    DARK: "#00766A",
    DEFAULT: "#00897B",
    LIGHT: "#B9E6CD",
    LIGHTER: "#E0F2E3",
    LIGHTEST: "#F0F9F4"
};


const $16de00684bfb1bde$export$1c78d5d38fd7ee92 = {
    DARKEST: "#425A00",
    DARKER: "#698128",
    DARK: "#85A136",
    DEFAULT: "#9BBE3C",
    LIGHT: "#DDE995",
    LIGHTER: "#EAF6B9",
    LIGHTEST: "#F6FAE7"
};


const $482fd5d8bda6e646$export$64fdd419ec8dbc36 = {
    DARKEST: "#7D4F00",
    DARKER: "#A36700",
    DARK: "#CC8100",
    DEFAULT: "#FFA000",
    LIGHT: "#FEB874",
    LIGHTER: "#FFECB8",
    LIGHTEST: "#FFFAE9",
    TRANSPARENT: "rgba(255, 248, 225, 0.5)"
};


const $9fda19fcc55c67ba$export$d68d0fda4a10dbc2 = {
    DARKEST: "#771C6E",
    DARKER: "#AF50A0",
    DARK: "#DA7ECB",
    DEFAULT: "#F1CEEC",
    LIGHT: "#F0E0EF",
    LIGHTER: "#F3E8F2",
    LIGHTEST: "#F9F2F8"
};


const $dd025f78435efafa$export$eb89ee75e7d64ec3 = {
    DANGER: $68f5c7d2b84fdd64$export$9c2c904c75cdf110,
    GREYSCALE: $a25a9bd37d8d246b$export$8cbd6e16cb024bee,
    PRIMARY: $3cb4d9c0e0bb20b9$export$fd2a60be71b279b3,
    SECONDARY: $0511212feaf5f145$export$ff5b17dd5d816620,
    SUCCESS: $56f49b91f684431c$export$638cc6e36b2a737a,
    TERTIARY: $16de00684bfb1bde$export$1c78d5d38fd7ee92,
    WARNING: $482fd5d8bda6e646$export$64fdd419ec8dbc36,
    PINK: $9fda19fcc55c67ba$export$d68d0fda4a10dbc2
};


const $e16082be2a942b6d$export$472f663fe3c30434 = {
    PRIMARY: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PRIMARY.DEFAULT,
    PRIMARY_LIGHT: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PRIMARY.LIGHT,
    PRIMARY_LIGHTER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PRIMARY.LIGHTER,
    PRIMARY_LIGHTEST: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PRIMARY.LIGHTEST,
    SECONDARY: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SECONDARY.DEFAULT,
    SECONDARY_LIGHT: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SECONDARY.LIGHT,
    SECONDARY_LIGHTER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SECONDARY.LIGHTER,
    SECONDARY_LIGHTEST: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SECONDARY.LIGHTEST,
    TERTIARY_LIGHTER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).TERTIARY.LIGHTER,
    TERTIARY_LIGHTEST: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).TERTIARY.LIGHTEST,
    SUCCESS: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SUCCESS.DEFAULT,
    SUCCESS_LIGHTER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SUCCESS.LIGHTER,
    SUCCESS_LIGHTEST: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SUCCESS.LIGHTEST,
    WARNING: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).WARNING.DEFAULT,
    WARNING_LIGHTER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).WARNING.LIGHTER,
    WARNING_LIGHTEST: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).WARNING.LIGHTEST,
    DANGER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).DANGER.DEFAULT,
    DANGER_LIGHT: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).DANGER.LIGHT,
    DANGER_LIGHTER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).DANGER.LIGHTER,
    DANGER_LIGHTEST: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).DANGER.LIGHTEST,
    DANGER_DARK: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).DANGER.DARK,
    PINK_LIGHT: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PINK.LIGHT,
    PINK_LIGHTEST: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PINK.LIGHTEST,
    GREY: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.DEFAULT,
    GREY_LIGHTER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.LIGHTER,
    GREY_LIGHTEST: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.LIGHTEST,
    WHITE: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.WHITE,
    MODAL_BACKGROUND: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.BLACK_TRANSPARENT,
    TRANSPARENT: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.TRANSPARENT
};



const $6aab9fb59893d9da$export$45478fb41c4ce571 = {
    PRIMARY: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PRIMARY.DEFAULT,
    SECONDARY: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SECONDARY.DEFAULT,
    SUCCESS: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SUCCESS.DEFAULT,
    WARNING: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).WARNING.DEFAULT,
    DANGER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).DANGER.DEFAULT,
    LIGHT: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.DEFAULT,
    DARK: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.DARKER
};




const $8e8d0ea7111c56c9$export$78dafc18d6355ced = {
    PRIMARY: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PRIMARY.DEFAULT,
    SECONDARY: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SECONDARY.DEFAULT,
    SECONDARY_DARK: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SECONDARY.DARK,
    SUCCESS: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SUCCESS.DARK,
    WARNING: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).WARNING.DARKER,
    DANGER: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).DANGER.DARK,
    BLACK: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.BLACK,
    GREY: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.DARKEST,
    DISABLED: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.DARKER,
    WHITE: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).GREYSCALE.WHITE
};



const $a28ccf674abf441e$export$e90019473554f70a = {
    SUCCESS: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).SUCCESS.LIGHTEST,
    ERROR: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).DANGER.LIGHTEST,
    NEUTRAL: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).PRIMARY.LIGHTER,
    WARNING: (0, $dd025f78435efafa$export$eb89ee75e7d64ec3).WARNING.LIGHTEST
};


const $5ecbefaf714b3608$export$56d196d2844d1ca1 = {
    BACKGROUND_COLORS: $e16082be2a942b6d$export$472f663fe3c30434,
    BORDER_COLORS: $6aab9fb59893d9da$export$45478fb41c4ce571,
    PALETTE: $dd025f78435efafa$export$eb89ee75e7d64ec3,
    TEXT_COLORS: $8e8d0ea7111c56c9$export$78dafc18d6355ced,
    ALERT_COLORS: $a28ccf674abf441e$export$e90019473554f70a
};



var $c24c819ac9708802$exports = {};

$parcel$export($c24c819ac9708802$exports, "getResolution", () => $c24c819ac9708802$export$709fa427476941ba);

const $c24c819ac9708802$export$709fa427476941ba = ()=>{
    const width = window.innerWidth;
    if (width <= (0, $c9a2d196d5ac23f3$export$426e07cd0772984d).SM) return "SM";
    if (width <= (0, $c9a2d196d5ac23f3$export$426e07cd0772984d).MD) return "MD";
    if (width <= (0, $c9a2d196d5ac23f3$export$426e07cd0772984d).LG) return "LG";
    if (width <= (0, $c9a2d196d5ac23f3$export$426e07cd0772984d).XL) return "XL";
    return "XXL";
};


var $edd7d6480043c420$exports = {};

$parcel$export($edd7d6480043c420$exports, "SHADOWS", () => $edd7d6480043c420$export$91f6dc1e63b7cbc6);
const $edd7d6480043c420$export$91f6dc1e63b7cbc6 = {
    TOP_LIGHT: `box-shadow: 0 -4px 8px rgba(104, 115, 130, 0.08);`,
    TOP: `box-shadow: 0 -4px 16px rgba(104, 115, 130, 0.16);`,
    TOP_DARK: `box-shadow: 0 -4px 24px rgba(104, 115, 130, 0.24);`,
    BOTTOM_LIGHT: `box-shadow: 0 4px 8px rgba(104, 115, 130, 0.08);`,
    BOTTOM: `box-shadow: 0 4px 16px rgba(104, 115, 130, 0.16);`,
    BOTTOM_DARK: `box-shadow: 0 4px 24px rgba(104, 115, 130, 0.24);`
};


var $aa9d2ca76d4d6ba5$exports = {};

$parcel$export($aa9d2ca76d4d6ba5$exports, "SIZES", () => $aa9d2ca76d4d6ba5$export$57732b6846a8df7c);

const $1414c3a4bbe9c605$var$SM = {
    value: 32,
    px: "32px",
    rem: `${32 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $1414c3a4bbe9c605$var$MD = {
    value: 40,
    px: "40px",
    rem: `${40 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $1414c3a4bbe9c605$var$LG = {
    value: 80,
    px: "80px",
    rem: `${80 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $1414c3a4bbe9c605$var$XL = {
    value: 160,
    px: "160px",
    rem: `${160 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $1414c3a4bbe9c605$export$1b64e3a5860d85af = {
    SM: $1414c3a4bbe9c605$var$SM,
    MD: $1414c3a4bbe9c605$var$MD,
    LG: $1414c3a4bbe9c605$var$LG,
    XL: $1414c3a4bbe9c605$var$XL
};



const $f76565235c712844$var$XS = {
    value: 8,
    px: "8px",
    rem: `${8 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $f76565235c712844$var$SM = {
    value: 12,
    px: "12px",
    rem: `${12 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $f76565235c712844$var$MD = {
    value: 16,
    px: "16px",
    rem: `${16 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $f76565235c712844$var$LG = {
    value: 24,
    px: "24px",
    rem: `${24 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $f76565235c712844$export$d2b60e6b56e900e8 = {
    XS: $f76565235c712844$var$XS,
    SM: $f76565235c712844$var$SM,
    MD: $f76565235c712844$var$MD,
    LG: $f76565235c712844$var$LG
};



const $7bc6d3ff89aa8508$var$SM = {
    value: 40,
    px: "40px",
    rem: `${40 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $7bc6d3ff89aa8508$var$MD = {
    value: 60,
    px: "60px",
    rem: `${60 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $7bc6d3ff89aa8508$var$LG = {
    value: 80,
    px: "80px",
    rem: `${80 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $7bc6d3ff89aa8508$var$XL = {
    value: 160,
    px: "160px",
    rem: `${160 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $7bc6d3ff89aa8508$var$XXL = {
    value: 240,
    px: "240px",
    rem: `${240 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $7bc6d3ff89aa8508$export$13db6c6ae2af21d8 = {
    SM: $7bc6d3ff89aa8508$var$SM,
    MD: $7bc6d3ff89aa8508$var$MD,
    LG: $7bc6d3ff89aa8508$var$LG,
    XL: $7bc6d3ff89aa8508$var$XL,
    XXL: $7bc6d3ff89aa8508$var$XXL
};
const $7bc6d3ff89aa8508$export$74f94c628b84d921 = {};


const $12cf41a2bb4e6379$var$WEB_NAVBAR_WIDTH = {
    SM: "100%",
    MD: "100%",
    LG: "1170px"
};
const $12cf41a2bb4e6379$var$WEB_NAVBAR_HEIGHT = {
    SM: "56px",
    MD: "56px",
    LG: "72px"
};
const $12cf41a2bb4e6379$var$WEB_FOOTER_HEIGHT = {
    SM: "261px",
    MD: "285px",
    LG: "141px"
};
const $12cf41a2bb4e6379$var$CONTENT_WIDTH = {
    SM: "100%",
    MD: "100%",
    LG: "600px"
};
const $12cf41a2bb4e6379$export$d3d35020fa5b54f0 = {
    WEB_NAVBAR_WIDTH: $12cf41a2bb4e6379$var$WEB_NAVBAR_WIDTH,
    WEB_NAVBAR_HEIGHT: $12cf41a2bb4e6379$var$WEB_NAVBAR_HEIGHT,
    WEB_FOOTER_HEIGHT: $12cf41a2bb4e6379$var$WEB_FOOTER_HEIGHT,
    CONTENT_WIDTH: $12cf41a2bb4e6379$var$CONTENT_WIDTH
};


const $aa9d2ca76d4d6ba5$export$57732b6846a8df7c = {
    AVATAR: $1414c3a4bbe9c605$export$1b64e3a5860d85af,
    ICON: $f76565235c712844$export$d2b60e6b56e900e8,
    IMAGE: $7bc6d3ff89aa8508$export$74f94c628b84d921,
    ILLUSTRATION: $7bc6d3ff89aa8508$export$13db6c6ae2af21d8,
    PAGE: $12cf41a2bb4e6379$export$d3d35020fa5b54f0
};


var $a80b6f1dd693c39b$exports = {};

$parcel$export($a80b6f1dd693c39b$exports, "SPACING", () => $a80b6f1dd693c39b$export$82ea42e772d49e5b);

const $ee65648a382e5d30$export$c53d0f541b41b88e = {
    value: 0,
    rem: "0rem",
    px: "0px"
};
const $ee65648a382e5d30$export$78e3cbc05a952198 = {
    value: 4,
    px: "4px",
    rem: `${4 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$7ef8b05b9f57e903 = {
    value: 8,
    px: "8px",
    rem: `${8 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$59096964bd9627ef = {
    value: 12,
    px: "12px",
    rem: `${12 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$3c37c3bdb860ae1e = {
    value: 16,
    px: "16px",
    rem: `${16 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$6ebfb25b2e903298 = {
    value: 24,
    px: "24px",
    rem: `${24 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$b225dbe5fb1f12f8 = {
    value: 32,
    px: "32px",
    rem: `${32 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$8214debbabae9604 = {
    value: 48,
    px: "48px",
    rem: `${48 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$71feb715d416766e = {
    value: 64,
    px: "64px",
    rem: `${64 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$535aa684ab106f9f = {
    value: 80,
    px: "80px",
    rem: `${80 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$12cb9567314688c2 = {
    value: 160,
    px: "160px",
    rem: `${160 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
};
const $ee65648a382e5d30$export$6afe12cefc2d6c90 = {
    XXS: $ee65648a382e5d30$export$78e3cbc05a952198,
    XS: $ee65648a382e5d30$export$7ef8b05b9f57e903,
    SM: $ee65648a382e5d30$export$59096964bd9627ef,
    MD: $ee65648a382e5d30$export$3c37c3bdb860ae1e,
    LG: $ee65648a382e5d30$export$6ebfb25b2e903298,
    XL: $ee65648a382e5d30$export$b225dbe5fb1f12f8,
    XXL: $ee65648a382e5d30$export$8214debbabae9604,
    XXXL: $ee65648a382e5d30$export$71feb715d416766e,
    XXXXL: $ee65648a382e5d30$export$535aa684ab106f9f,
    XXXXXL: $ee65648a382e5d30$export$12cb9567314688c2,
    NONE: $ee65648a382e5d30$export$c53d0f541b41b88e
};


const $a80b6f1dd693c39b$export$82ea42e772d49e5b = {
    STATIC: $ee65648a382e5d30$export$6afe12cefc2d6c90
};


var $cf352c90ed79e02d$exports = {};

$parcel$export($cf352c90ed79e02d$exports, "TYPOGRAPHY", () => $cf352c90ed79e02d$export$d36796ab73e728d9);
$parcel$export($cf352c90ed79e02d$exports, "fontByPlatform", () => $cf352c90ed79e02d$export$db2f0c4592465d07);
const $ff0dbba8158c7a80$export$75d3998385cc196f = {
    BODY: {
        REGULAR: "Inter-Regular",
        REGULAR_ITALIC: "Inter-Italic",
        SEMIBOLD: "Inter-SemiBold",
        SEMIBOLD_ITALIC: "Inter-SemiBoldItalic",
        BOLD: "Inter-Bold",
        BOLD_ITALIC: "Inter-BoldItalic"
    },
    HEADER: {
        REGULAR: "GalaxieCopernicus-Book",
        SEMIBOLD: "GalaxieCopernicus-Semibold"
    }
};


const $f6b5cdc0cfcd54a7$export$abd5f4ea4c66db1d = {
    BODY: {
        REGULAR: "Inter-Regular",
        REGULAR_ITALIC: "Inter-Italic",
        SEMIBOLD: "Inter-SemiBold",
        SEMIBOLD_ITALIC: "Inter-SemiBoldItalic",
        BOLD: "Inter-Bold",
        BOLD_ITALIC: "Inter-BoldItalic"
    },
    HEADER: {
        REGULAR: "GalaxieCopernicus-Book",
        SEMIBOLD: "GalaxieCopernicus-Semibold"
    }
};


const $95203d5a1ff2c7af$export$7c1c6d23e24077e6 = {
    BODY: {
        REGULAR: "Inter-Regular",
        REGULAR_ITALIC: "Inter-Italic",
        SEMIBOLD: "Inter-SemiBold",
        SEMIBOLD_ITALIC: "Inter-SemiBoldItalic",
        BOLD: "Inter-Bold",
        BOLD_ITALIC: "Inter-BoldItalic"
    },
    HEADER: {
        REGULAR: "Copernicus-Book",
        SEMIBOLD: "Copernicus-Semibold"
    }
};


const $11c3871896416b4d$export$6ebfb25b2e903298 = {
    value: 0.3,
    px: "0.3px"
};
const $11c3871896416b4d$export$3c37c3bdb860ae1e = {
    value: 0,
    px: "0px"
};
const $11c3871896416b4d$export$59096964bd9627ef = {
    value: -0.3,
    px: "-0.3px"
};
const $11c3871896416b4d$export$dd8c478849ec1bc7 = {
    LG: $11c3871896416b4d$export$6ebfb25b2e903298,
    MD: $11c3871896416b4d$export$3c37c3bdb860ae1e,
    SM: $11c3871896416b4d$export$59096964bd9627ef
};


const $2bc5a85f753e6546$export$42510bee89f29ff9 = {
    LG: 1.5,
    MD: 1.25,
    SM: 1
};



const $a07fe7e5f69cfeb2$export$d597759d33be802e = {
    HEADER: {
        XL: {
            value: 48,
            px: "48px",
            rem: `${48 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        },
        LG: {
            value: 32,
            px: "32px",
            rem: `${32 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        },
        MD: {
            value: 24,
            px: "24px",
            rem: `${24 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        },
        SM: {
            value: 20,
            px: "20px",
            rem: `${20 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        },
        XS: {
            value: 18,
            px: "18px",
            rem: `${18 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        }
    },
    BODY: {
        LG: {
            value: 18,
            px: "18px",
            rem: `${18 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        },
        MD: {
            value: 16,
            px: "16px",
            rem: `${16 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        },
        SM: {
            value: 14,
            px: "14px",
            rem: `${14 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        }
    },
    DETAIL: {
        LG: {
            value: 12,
            px: "12px",
            rem: `${12 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        },
        MD: {
            value: 10,
            px: "10px",
            rem: `${10 / (0, $fd56662dee1a030a$export$268e222a7ce18ec6)}rem`
        }
    }
};


var $e76c613412731c7a$exports = {};

$parcel$export($e76c613412731c7a$exports, "iconDefaultVariant", () => $e76c613412731c7a$export$4f2ae063026d2944);
$parcel$export($e76c613412731c7a$exports, "iconColorVariants", () => $e76c613412731c7a$export$dc7fbbf199db0a4e);
$parcel$export($e76c613412731c7a$exports, "iconColorVariantList", () => $e76c613412731c7a$export$e06007cc744191d4);
$parcel$export($e76c613412731c7a$exports, "variantPostfixes", () => $e76c613412731c7a$export$ef8f18cd5c66f1c0);
$parcel$export($e76c613412731c7a$exports, "generateIconUrl", () => $e76c613412731c7a$export$2b24a09597f9fdcd);
$parcel$export($e76c613412731c7a$exports, "altoIconToUrlMap", () => $e76c613412731c7a$export$ecabd04e64632f3c);

const $e76c613412731c7a$var$baseIcons = {
    alert: true,
    bank: true,
    bell: true,
    bookmark: true,
    box: true,
    briefcasemedical: true,
    cake: true,
    calendar: true,
    calendarcheck: true,
    camera: true,
    cancel: true,
    capsule: true,
    car: true,
    cart: true,
    chart: true,
    checkbox: true,
    checkcircle: true,
    checklist: true,
    checkmark: true,
    chevroncircledown: true,
    chevroncircleup: true,
    chevrondown: true,
    chevronup: true,
    chevronleft: true,
    chevronright: true,
    clock: true,
    close: true,
    closecircle: true,
    copy: true,
    creditcard: true,
    doctor: true,
    doctorplus: true,
    download: true,
    edit: true,
    ellipsish: true,
    ellipsisv: true,
    externallink: true,
    eyeclosed: true,
    eyeopen: true,
    faceid: true,
    filter: true,
    fingerprint: true,
    gear: true,
    handbox: true,
    home: true,
    homelock: true,
    hourglass: true,
    idcard: true,
    info: true,
    injectorpen: true,
    link: true,
    loader: true,
    mail: true,
    mapmarker: true,
    message: true,
    messagequestion: true,
    minus: true,
    paperairplane: true,
    patch: true,
    people: true,
    percent: true,
    phone: true,
    pill: true,
    pills: true,
    pillbottle: true,
    plus: true,
    pluscircle: true,
    pricetag: true,
    questionmark: true,
    radio: true,
    rxchart: true,
    search: true,
    settings: true,
    shield: true,
    shieldslash: true,
    signature: true,
    signpaper: true,
    snowflake: true,
    star: true,
    store: true,
    lightning: true,
    suppository: true,
    swap: true,
    sync: true,
    syringe: true,
    testtube: true,
    topical: true,
    towelette: true,
    trash: true,
    truck: true,
    user: true,
    usercircle: true,
    userplus: true
};
const $e76c613412731c7a$export$4f2ae063026d2944 = {
    main: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).TEXT_COLORS.PRIMARY,
    duo: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).PALETTE.SECONDARY.LIGHT
};
const $e76c613412731c7a$export$dc7fbbf199db0a4e = {
    secondary: {
        main: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).TEXT_COLORS.SECONDARY,
        duo: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).PALETTE.SECONDARY.LIGHT
    },
    grey: {
        main: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).TEXT_COLORS.GREY,
        duo: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).PALETTE.GREYSCALE.DEFAULT
    },
    disabled: {
        main: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).PALETTE.GREYSCALE.DARKER,
        duo: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).PALETTE.GREYSCALE.DEFAULT
    },
    success: {
        main: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).TEXT_COLORS.SUCCESS,
        duo: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).PALETTE.SUCCESS.LIGHT
    },
    danger: {
        main: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).TEXT_COLORS.DANGER,
        duo: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).PALETTE.DANGER.LIGHTER
    },
    white: {
        main: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).TEXT_COLORS.WHITE,
        duo: (0, $5ecbefaf714b3608$export$56d196d2844d1ca1).PALETTE.GREYSCALE.DARKER
    }
};
const $e76c613412731c7a$export$e06007cc744191d4 = Object.keys($e76c613412731c7a$export$dc7fbbf199db0a4e);
const $e76c613412731c7a$export$ef8f18cd5c66f1c0 = [
    "small",
    "duo"
];
const $e76c613412731c7a$export$2b24a09597f9fdcd = (name)=>`https://assets.prod.alto.com/icons/${name}.svg`;
// loops through all variant types to create a list of all valid icon names
const $e76c613412731c7a$var$allIconNames = [];
Object.keys($e76c613412731c7a$var$baseIcons).forEach((baseIconName)=>{
    $e76c613412731c7a$var$allIconNames.push(baseIconName);
    $e76c613412731c7a$export$ef8f18cd5c66f1c0.forEach((variantPostfix)=>{
        $e76c613412731c7a$var$allIconNames.push(`${baseIconName}-${variantPostfix}`);
        $e76c613412731c7a$export$e06007cc744191d4.forEach((iconColorVariant)=>{
            $e76c613412731c7a$var$allIconNames.push(`${baseIconName}-${iconColorVariant}`);
            $e76c613412731c7a$var$allIconNames.push(`${baseIconName}-${variantPostfix}-${iconColorVariant}`);
        });
    });
});
const $e76c613412731c7a$export$ecabd04e64632f3c = $e76c613412731c7a$var$allIconNames.reduce((reduced, iconName)=>{
    reduced[iconName] = $e76c613412731c7a$export$2b24a09597f9fdcd(iconName);
    return reduced;
}, {});


const $cf352c90ed79e02d$export$d36796ab73e728d9 = {
    FONT: $ff0dbba8158c7a80$export$75d3998385cc196f,
    FONT_ANDROID: $f6b5cdc0cfcd54a7$export$abd5f4ea4c66db1d,
    FONT_IOS: $95203d5a1ff2c7af$export$7c1c6d23e24077e6,
    LETTER_SPACING: $11c3871896416b4d$export$dd8c478849ec1bc7,
    LINE_HEIGHT: $2bc5a85f753e6546$export$42510bee89f29ff9,
    TEXT: $a07fe7e5f69cfeb2$export$d597759d33be802e
};
const $cf352c90ed79e02d$export$db2f0c4592465d07 = (platform)=>{
    if (platform === "ios") return 0, $95203d5a1ff2c7af$export$7c1c6d23e24077e6;
    if (platform === "android") return 0, $f6b5cdc0cfcd54a7$export$abd5f4ea4c66db1d;
    return 0, $ff0dbba8158c7a80$export$75d3998385cc196f;
};
$parcel$exportWildcard($cf352c90ed79e02d$exports, $e76c613412731c7a$exports);


var $c752a5f672f78436$exports = {};

$parcel$export($c752a5f672f78436$exports, "Z_INDEX", () => $c752a5f672f78436$export$42310dd57a41067);
const $c752a5f672f78436$export$42310dd57a41067 = {
    Z_99999: 99999,
    Z_400: 400,
    Z_300: 300,
    Z_200: 200,
    Z_100: 100,
    Z_DEFAULT: 0,
    Z_MINUS_100: -100,
    Z_MINUS_200: -200,
    Z_MINUS_300: -300,
    Z_MINUS_400: -400,
    Z_MINUS_999999: -999999
};




export {$8acc2c0717e3c0a9$export$a8fef325e42f6db3 as ANIMATION, $0cde332632c6cb01$export$ba7bb3842aa42e48 as BORDERS, $c9a2d196d5ac23f3$export$426e07cd0772984d as BREAKPOINTS, $c9a2d196d5ac23f3$export$7e1b78538df536d8 as DEVICES, $5ecbefaf714b3608$export$56d196d2844d1ca1 as COLORS, $fd56662dee1a030a$export$268e222a7ce18ec6 as BASE_FONT_SIZE, $c24c819ac9708802$export$709fa427476941ba as getResolution, $edd7d6480043c420$export$91f6dc1e63b7cbc6 as SHADOWS, $aa9d2ca76d4d6ba5$export$57732b6846a8df7c as SIZES, $a80b6f1dd693c39b$export$82ea42e772d49e5b as SPACING, $cf352c90ed79e02d$export$d36796ab73e728d9 as TYPOGRAPHY, $cf352c90ed79e02d$export$db2f0c4592465d07 as fontByPlatform, $e76c613412731c7a$export$4f2ae063026d2944 as iconDefaultVariant, $e76c613412731c7a$export$dc7fbbf199db0a4e as iconColorVariants, $e76c613412731c7a$export$e06007cc744191d4 as iconColorVariantList, $e76c613412731c7a$export$ef8f18cd5c66f1c0 as variantPostfixes, $e76c613412731c7a$export$2b24a09597f9fdcd as generateIconUrl, $e76c613412731c7a$export$ecabd04e64632f3c as altoIconToUrlMap, $c752a5f672f78436$export$42310dd57a41067 as Z_INDEX};
//# sourceMappingURL=module.js.map
